<!--

typeinfo: {
    getItems: function which returns a promise with a list of items
    text: item text field (name, title or similar)
    value: item value (id, name or similar)
    multiple: boolean, true if multiple items can be selected
    placeholder: Placeholder text
    order: A different interface where order between items can be changed
    selectFirst: If true, the first item will be selected automatically
}

-->


<template>
    <v-select
        v-if="!prop.typeinfo.order"
        :label="label"
        :items="sortedItems"
        :clearable="!prop.typeinfo.selectFirst"
        :item-text="prop.typeinfo.text"
        :item-value="prop.typeinfo.value"
        :multiple="prop.typeinfo.multiple"
        v-bind:value="selected"
        v-on:input="setValue"
        :placeholder="$translate(prop.typeinfo.placeholder)"
        :hint="hint"
    />
    <div v-else>
        <label class="v-label theme--light">{{label}}</label>
        <v-list>
            <draggable v-model="selected" @change="$emit('input', selected)" tag="ContentsContainer">
                <v-list-item v-for="(item,itemindex) in selectedItems" :key="item.id" style="cursor: move">
                    <v-row no-gutters>
                        <v-col cols=10 class="black--text">
                            <v-auto-img v-if="item.imagekey" class="d-inline-block" :src="item.imagekey" width="50" height="50" />
                            <span class="ml-4">{{item[prop.typeinfo.text]}}</span>
                        </v-col>
                        <v-col cols=2>
                            <v-btn
                                @click="removeItem(itemindex)"
                                color="error"
                                fab
                                small
                                style="margin-left: 8px"
                            >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item>
            </draggable>
        </v-list>

        <v-select :key="removeKey"
            :placeholder="((selected && selected.length) || !prop.typeinfo.placeholder) ? $translate('Choose to add') : $translate(prop.typeinfo.placeholder)"
            :items="toadd"
            :item-text="prop.typeinfo.text"
            :item-value="prop.typeinfo.value"
            :hint="hint"
            @input="addItem"
        />
    </div>
</template>

<script>
import Draggable from 'vuedraggable';

export default {
    name: 'SelectSetting',

    components: {
        Draggable
    },

    props: ['value', 'label', 'prop', 'props', 'hint'],
    data: () => ({
        selected: null,
        items: [],
        removeKey: 0
    }),
    computed: {
        sortedItems() {
            // Clone the items array to create a new independent copy, preventing any modifications to the original array
            let items = JSON.parse(JSON.stringify(this.items));

            items = items.filter(this.prop.typeinfo.filter ? ((x) => this.prop.typeinfo.filter(x, this.props)) : (() => true));

            // Translate title of items
            items.forEach(x => x[this.prop.typeinfo.text] = this.$translate(x[this.prop.typeinfo.text]));

            if (this.prop.typeinfo.nosort) {
                return items;
            }

            return items.sort((a, b) => a[this.prop.typeinfo.text].localeCompare(b[this.prop.typeinfo.text]))
        },
        toadd() {
            return this.sortedItems.filter(x => this.selected.indexOf(x.id) == -1);
        },
        selectedItems() {
            return this.selected.map(x => this.items.find(i => i.id == x)).filter(x => x);
        }
    },
    watch: {
        sortedItems: {
            immediate: true,
            handler(items) {
                if (this.prop.typeinfo.selectFirst && items && items.length) {
                    let hasValue = this.prop.typeinfo.multiple ? (this.selected && this.selected.length) : this.selected;
                    if (!hasValue) {
                        let first = items[0][this.prop.typeinfo.value];
                        this.setValue(this.prop.typeinfo.multiple ? [first] : first);
                    }
                }
            }
        }
    },
    methods: {
        setValue(value) {
            this.selected = value && this.prop.typeinfo.multiple ? value.filter(x => x !== null) : value;
            this.$emit('input', this.selected)
        },
        addItem(value) {
            this.selected.push(value);
            this.$emit('input', this.selected)
        },
        removeItem(itemindex) {
            this.selected.splice(itemindex, 1);
            this.$emit('input', this.selected);
            ++this.removeKey;
        }
    },
    mounted() {
        this.selected = this.prop.typeinfo.multiple && this.value && typeof this.value !== 'object' ? [this.value] : this.value;
        if (this.prop.typeinfo.multiple && !this.value) {
            this.selected = [];
        }
        let items = this.prop.typeinfo.getItems();
        if (items.then) {
            items.then(x => this.items = x);
        } else {
            this.items = items;
        }
    }
  }
</script>